import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface WaveformLoadingIndicatorProps {
  isLoading: boolean;
  isReady: boolean;
  audioFileId: number;
}

const WaveformLoadingIndicator: React.FC<WaveformLoadingIndicatorProps> = ({
  isLoading,
  isReady,
  audioFileId
}) => {
  // Only show when there's an audio file loaded
  if (audioFileId === 0) {
    return null;
  }

  // Show green checkmark when ready (prioritize ready state)
  if (isReady && !isLoading) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: '-50px',
          right: '8px',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#4caf50',
          borderRadius: '50%',
          boxShadow: '0 2px 8px rgba(76, 175, 80, 0.25)',
          zIndex: 10,
        }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
            fill="white"
          />
        </svg>
      </Box>
    );
  }

  // Show loading spinner when loading or not ready
  if (isLoading || !isReady) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: '-50px',
          right: '8px',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '50%',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          zIndex: 10,
          backdropFilter: 'blur(4px)',
        }}
      >
        <CircularProgress 
          size={18} 
          thickness={4}
          sx={{ color: 'var(--primary)' }}
        />
      </Box>
    );
  }

  return null;
};

export default WaveformLoadingIndicator;

